// extracted by mini-css-extract-plugin
export default {"clientsBlock":"ClientsBlock_clientsBlock__u-Kh0","title":"ClientsBlock_title__BgcUR","clients":"ClientsBlock_clients__VETZp"};